{
  "name": "@xiboplayer/schedule",
  "version": "0.7.23",
  "description": "Complete scheduling solution: campaigns, dayparting, interrupts, and overlays",
  "type": "module",
  "main": "./src/index.js",
  "types": "./src/index.d.ts",
  "exports": {
    ".": "./src/index.js",
    "./schedule": "./src/schedule.js",
    "./interrupts": "./src/interrupts.js",
    "./overlays": "./src/overlays.js"
  },
  "scripts": {
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "@xiboplayer/utils": "workspace:*"
  },
  "devDependencies": {
    "vitest": "^4.1.2"
  },
  "keywords": [
    "xibo",
    "digital-signage",
    "scheduling",
    "dayparting",
    "campaigns",
    "interrupts",
    "overlays",
    "shareOfVoice"
  ],
  "author": "Pau Aliagas <linuxnow@gmail.com>",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xibo-players/xiboplayer.git",
    "directory": "packages/schedule"
  },
  "homepage": "https://xiboplayer.org"
}
